import React, { useState, useMemo } from 'react';
import { styles } from './lib/ui';

export default function StudioCamPresetPanel({
  instance,
  presets = [],
  currentCmd = '',
  onApplyPreset,
  onClose,
  loading = false,
}) {
  const [successMessage, setSuccessMessage] = useState('');

  const role = useMemo(() => {
    const raw = String(instance?.role || '').toLowerCase();
    if (raw === 'audio' || raw === 'video') return raw;
    const name = String(instance?.camName || '').toLowerCase();
    if (name.includes('mic') || name.includes('audio') || name.includes('voice')) return 'audio';
    return 'video';
  }, [instance]);

  // Filtrar presets por rol
  const filteredPresets = useMemo(
    () => presets.filter(p => !p.role || p.role === role),
    [presets, role]
  );

  // Detectar el preset actual por comando (ignorar espacios y saltos de línea)
  function normalizeCmd(cmd) {
    return String(cmd || '').replace(/\s+/g, ' ').trim();
  }
  const currentPreset = useMemo(() => {
    if (!currentCmd) return null;
    // Buscar por comando normalizado
    const byCmd = filteredPresets.find(p => normalizeCmd(p.command) === normalizeCmd(currentCmd));
    if (byCmd) return byCmd;
    // Buscar por nombre si la instancia tiene presetName
    if (instance?.presetName) {
      const byName = filteredPresets.find(p => p.name === instance.presetName);
      if (byName) return byName;
    }
    return null;
  }, [filteredPresets, currentCmd, instance]);

  // Dropdown always starts at placeholder — user picks explicitly
  const [selectedPresetId, setSelectedPresetId] = useState('');

  const selectedPreset = useMemo(
    () => filteredPresets.find(p => p._id === selectedPresetId) || null,
    [filteredPresets, selectedPresetId]
  );

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{ background: '#23243a', color: '#fff', borderRadius: 16, padding: 32, minWidth: 340, maxWidth: 420, boxShadow: '0 4px 32px #000', position: 'relative' }}>
        <button onClick={onClose} style={{ position: 'absolute', top: 16, right: 16, background: '#9a51e2', color: '#fff', border: 'none', borderRadius: 8, fontSize: 18, padding: '8px 16px', cursor: 'pointer', zIndex: 10 }}>Close</button>
        <h3 style={{ marginTop: 0, marginBottom: 12 }}>Select FFmpeg Preset</h3>
        <div style={{ marginBottom: 12 }}>
          <b>Camera:</b> {instance?.camName} <br />
          <b>IP:</b> {instance?.publicIp}
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={{ color: '#9a51e2', fontWeight: 500 }}>Preset</label>
          <select
            value={selectedPresetId}
            onChange={e => setSelectedPresetId(e.target.value)}
            style={{ width: '100%', padding: 8, borderRadius: 6, background: '#181828', color: '#fff', border: '1px solid #555', marginTop: 4 }}
          >
            <option value="">— Select a preset —</option>
            {filteredPresets.map(p => (
              <option key={p._id} value={p._id}>
                {p.name}{p.isDefault ? ' (default)' : ''}
              </option>
            ))}
          </select>
        </div>
        {/* Show currently applied preset */}
        {currentPreset ? (
          <div style={{ marginBottom: 12, padding: '10px 12px', background: '#181828', borderRadius: 8, border: '1px solid #444', fontSize: 12 }}>
            <div style={{ color: '#9a51e2', fontWeight: 600 }}>Current: {currentPreset.name}{currentPreset.isDefault ? ' (default)' : ''}</div>
            {currentPreset.description && <div style={{ color: '#aaa', marginTop: 4 }}>{currentPreset.description}</div>}
          </div>
        ) : currentCmd ? (
          <div style={{ marginBottom: 12, padding: '10px 12px', background: '#181828', borderRadius: 8, border: '1px solid #555', fontSize: 12 }}>
            <div style={{ color: '#ff9800', fontWeight: 600 }}>Custom command (no preset match)</div>
          </div>
        ) : null}
        <button
          onClick={async () => {
            if (!selectedPresetId || !selectedPreset) return;
            setSuccessMessage('');
            await onApplyPreset(selectedPreset);
            setSuccessMessage(`Preset "${selectedPreset.name}" applied to ${instance.camName}`);
            setTimeout(() => {
              setSuccessMessage('');
              onClose();
            }, 3500);
          }}
          disabled={loading || !selectedPresetId}
          style={styles.btn('#4caf50')}
        >
          Apply Preset
        </button>
        {successMessage && (
          <p style={{ marginTop: 12, color: '#4caf50', fontWeight: 500, textAlign: 'center' }}>
            {successMessage}
          </p>
        )}
      </div>
    </div>
  );
}
